import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "CasinoNewGamesWidget" */ './CasinoNewGamesWidget'),
  modules: ['./CasinoNewGamesWidget'],
  loading: () => <div />
});

export default LoadableWidget;
